import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../utils/dt";
import { ServiceReport } from "../../models/ServiceReportsModel";
import PersonByline from "../PersonByline";
import useTranslation from "../../../../shared/hooks/useTranslation";

// ===================================================================
//  COMPONENT
// ===================================================================
interface SrPeopleCardProps {
  serviceReport: ServiceReport;
  isPhone: boolean;
}

const SrPeopleCard = ({ serviceReport, isPhone }: SrPeopleCardProps) => {
  const { translate } = useTranslation("myMachinery");

  // Only render if we have at least one person
  if (!serviceReport.createdByName && !serviceReport.solvedByName) {
    return null;
  }

  return (
    <Box
      sx={{
        background: dt.machinery.card.bg,
        border: dt.machinery.card.border,
        borderRadius: dt.machinery.card.radius,
        boxShadow: dt.machinery.card.shadow,
        padding: isPhone ? "16px" : "20px",
        fontFamily: dt.font,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        overflow: "hidden",
      }}
    >
      {/* Section header */}
      <Box
        sx={{
          fontFamily: dt.font,
          fontSize: "11px",
          fontWeight: 700,
          color: dt.serviceReports.detail.sectionLabelColor,
          textTransform: "uppercase",
          letterSpacing: "0.8px",
          mb: 0.25,
        }}
      >
        {translate("srDetail.people")}
      </Box>

      {serviceReport.createdByName && (
        <PersonByline
          variant="creator"
          label={translate("reportedBy")}
          name={serviceReport.createdByName}
          role={serviceReport.createdByRole}
          date={serviceReport.openDate}
          isPhone={isPhone}
        />
      )}

      {serviceReport.solvedByName && (
        <PersonByline
          variant="solver"
          label={translate("resolvedBy")}
          name={serviceReport.solvedByName}
          role={serviceReport.solvedByRole}
          date={serviceReport.closeDate}
          isPhone={isPhone}
        />
      )}
    </Box>
  );
};

export default SrPeopleCard;
